import { ListTypeEnum } from 'APIPackage/CatalogsModule/enums/ListTypeEnum';

const ROUTE_BASE = '/private';

export const ROUTE_LK = `${ROUTE_BASE}/lk`;
export const ROUTE_SMEV_MONITORING = `${ROUTE_BASE}/smev-monitoring`;
export const ROUTE_TEMPLATES = `${ROUTE_BASE}/templates`;
export const ROUTE_TEMPLATES_IMPORT = `${ROUTE_BASE}/import`;
export const ROUTE_TEMPLATES_EXPORT = `${ROUTE_BASE}/export`;
export const ROUTE_PLAN = `${ROUTE_BASE}/plan/:id`;
export const ROUTE_PLAN_BY_ID = (id: string | number, params?: string) =>
  `${ROUTE_BASE}/plan/${id}${params ? `?${params}` : ''}`;
export const ROUTE_KNM_LIST_BY_PLAN = `${ROUTE_BASE}/plan/:id/knms/:type`;
export const ROUTE_KNM_LIST_BY_ID_AND_TYPE = (id: string | number, type: ListTypeEnum) =>
  `${ROUTE_BASE}/plan/${id}/knms/${type}`;
export const ROUTE_SIMILARITIES = `${ROUTE_BASE}/similarities`;
export const ROUTE_FEEDBACK = `${ROUTE_BASE}/feedback`;
export const ROUTE_KNM_LIST = `${ROUTE_BASE}/knms`;
export const ROUTE_PREVENTION = `${ROUTE_BASE}/preventions`;
export const ROUTE_DECISIONS = `${ROUTE_BASE}/decisions`;
export const ROUTE_AGREEMENTS = `${ROUTE_BASE}/agreements`;
export const ROUTE_ANALYTICS = `${ROUTE_BASE}/analytics`;
export const ROUTE_ANALYTICS_PROSECTOR = `${ROUTE_BASE}/po-analytics`;
export const ROUTE_ANALYTICS_PROSECTOR_KNM = `${ROUTE_BASE}/po-analytics/knm`;
export const ROUTE_ANALYTICS_KNM = `${ROUTE_BASE}/analytics/knm`;
export const ROUTE_KNM_LIST_WITH_PLAN = (id: string | number) => `${ROUTE_BASE}/knms/${id}`;
export const ROUTE_REGISTRY_TOSER = `${ROUTE_BASE}/toser/:id`;
export const ROUTE_REGISTRY_TOSER_BY_ID = (id: number) => `${ROUTE_BASE}/toser/${id}`;
export const ROUTE_REGISTRY_SPV = `${ROUTE_BASE}/spv/:id`;
export const ROUTE_REGISTRY_SPV_BY_ID = (id: number) => `${ROUTE_BASE}/spv/${id}`;
export const ROUTE_REGISTRY_OEZ = `${ROUTE_BASE}/oez/:id`;
export const ROUTE_REGISTRY_OEZ_BY_ID = (id: number) => `${ROUTE_BASE}/oez/${id}`;
export const ROUTE_REGISTRY_EGRIP = `${ROUTE_BASE}/egrip/:id`;
export const ROUTE_REGISTRY_EGRIP_BY_ID = (id: number) => `${ROUTE_BASE}/egrip/${id}`;
export const ROUTE_REGISTRY_EGRUL = `${ROUTE_BASE}/egrul/:id`;
export const ROUTE_REGISTRY_EGRUL_BY_ID = (id: number) => `${ROUTE_BASE}/egrul/${id}`;
export const ROUTE_REGISTRY_MSP = `${ROUTE_BASE}/msp/:id`;
export const ROUTE_REGISTRY_MSP_BY_ID = (id: number) => `${ROUTE_BASE}/msp/${id}`;
export const ROUTE_SEARCH = `${ROUTE_BASE}/search`;
export const ROUTE_NEWS = `${ROUTE_BASE}/news`;
export const ROUTE_SYSTEM_INOPERABILITY = `${ROUTE_BASE}/system-inoperability`;
export const ROUTE_REPORTS = `${ROUTE_BASE}/reports`;
export const ROUTE_AUTH = `${ROUTE_BASE}/auth`;
export const ROUTE_INFO = `${ROUTE_LK}/info`;
export const ROUTE_CHECK_SHEETS = `${ROUTE_LK}/check-sheets`;
export const ROUTE_REQUIREMENTS = `${ROUTE_LK}/requirements`;

export const ROUTE_KNM_MASS_CANCELLATION = `${ROUTE_LK}/passport-mass-cancellation`;
export const ROUTE_PASSPORT_MASS_CANCELLATION_NEW_GROUP = `${ROUTE_KNM_MASS_CANCELLATION}/group/new`;
export const ROUTE_PASSPORT_MASS_CANCELLATION_GROUP = `${ROUTE_KNM_MASS_CANCELLATION}/group/:id`;
export const ROUTE_PASSPORT_MASS_CANCELLATION_GROUP_BY_ID = (id: string | number) =>
  `${ROUTE_KNM_MASS_CANCELLATION}/group/${id}`;

export const ROUTE_KNM_MASS_DELETION = `${ROUTE_LK}/passport-mass-deletion`;
export const ROUTE_PASSPORT_MASS_DELETION_NEW_GROUP = `${ROUTE_KNM_MASS_DELETION}/group/new`;
export const ROUTE_PASSPORT_MASS_DELETION_GROUP = `${ROUTE_KNM_MASS_DELETION}/group/:id`;
export const ROUTE_PASSPORT_MASS_DELETION_GROUP_BY_ID = (id: string | number) =>
  `${ROUTE_KNM_MASS_DELETION}/group/${id}`;

export const ROUTE_SETTINGS = `${ROUTE_LK}/settings`;
export const ROUTE_ADMIN_USERS = `${ROUTE_LK}/users`;
export const ROUTE_ADMIN_CATALOGS = `${ROUTE_LK}/catalogs`;
export const ROUTE_ADMIN_CATALOGS_UPDATE = `${ROUTE_LK}/catalogs-update`;
export const ROUTE_ADMIN_EXPORTS = `${ROUTE_LK}/exports`;
export const ROUTE_ADMIN_PAPERLESS = `${ROUTE_LK}/paperless`;
export const ROUTE_ADMIN_KNO_VALIDATION = `${ROUTE_LK}/kno-validation`;
export const ROUTE_ADMIN_NEWS = `${ROUTE_LK}/news`;
export const ROUTE_ADMIN_AUTOSAVE = `${ROUTE_LK}/autosave`;
export const ROUTE_ADMIN_INOPERABILITY = `${ROUTE_LK}/inoperability`;
export const ROUTE_ADMIN_NEWSLETTER = `${ROUTE_LK}/newsletter`;
export const ROUTE_ADMIN_END_CHECKING_ERP = `${ROUTE_LK}/end-checking-erp`;
export const ROUTE_ADMIN_MANGE_TEST_USER = `${ROUTE_LK}/manage-test-users`;
export const ROUTE_ADMIN_ADD_NEWS = `${ROUTE_BASE}/add-news`;
export const ROUTE_ADMIN_CHANGE_KNO_IN_PLAN = `${ROUTE_LK}/change-kno-in-plan`;
export const ROUTE_ADMIN_CHANGE_KNO_IN_MEASURE = `${ROUTE_LK}/change-kno-in-measure`;
export const ROUTE_ADMIN_PUBLISH_RULES = `${ROUTE_LK}/publish-rules`;
export const ROUTE_AUTHORIZED_TO_CONDUCT = `${ROUTE_LK}/authorized-to-conduct`;
export const ROUTE_ADMIN_HIDE_FIELDS = `${ROUTE_LK}/hide-fields`;
export const ROUTE_ADMIN_ADDING_PM_ERP = `${ROUTE_LK}/adding-pm-erp`;
export const ROUTE_ADMIN_SMEV = `${ROUTE_LK}/smev`;
// KnmPreview
export const ROUTE_KNM_PREVIEW = `${ROUTE_SEARCH}/knm/:id`;
export const ROUTE_KNM_PREVIEW_BY_ID = (id: string | number) => `${ROUTE_SEARCH}/knm/${id}`;
// KnmPage routes
export const NEW_KNM_ID = 'new';
export const ROUTE_KNM = (id: string | number, params?: string) =>
  `${ROUTE_BASE}/knm/${id}${params ? `?${params}` : ''}`;
export const ROUTE_KNM_FROM_ANALYTICS_ID = (id: string | number, params?: string) =>
  `${ROUTE_BASE}/knm/analytics/${id}${params ? `?${params}` : ''}`;
export const ROUTE_KNM_NEW = ROUTE_KNM(NEW_KNM_ID);
export const ROUTE_KNM_ID = `${ROUTE_BASE}/knm/:id`;
export const ROUTE_ANALYTICS_KNM_ID = `${ROUTE_BASE}/knm/analytics/:id`;
export const KNM_APPROVE_INFO = 'approve-info';
export const KNM_CANCELLATION_INFO = 'cancellation-info';
export const KNM_CHECK_SHEETS = 'check-sheets';
export const KNM_CONTROL_AGENCY = 'control-agency';
export const KNM_DOCUMENTS = 'documents';
export const DECISION_ACT = 'act';
export const KNM_EXECUTION_HISTORY = 'knm-execution-history';
export const ROUTE_ADMIN_IMMEDIATE_TEST_PURCHASE = `${ROUTE_LK}/immediate-test-purchase`;
export const KNM_HISTORY = 'knm-history';
export const KNM_PLAN_HISTORY = 'knm-plan-history';
export const KNM_PLAN_HISTORY_CHANGES = 'knm-plan-history-changes';
export const KNM_INFO = 'info';
export const KNM_LAWSUITS = 'lawsuits';
export const KNM_LINKS = 'links';
export const KNM_NOTICE_INFO = 'notice-info';
export const KNM_PREVIOUS = 'knm-previous';
export const KNM_REQUIREMENTS = 'requirements';
export const KNM_RESULTS = 'results';
export const KNM_SIGN_INFO = 'sign-info';
export const KNM_EPGU_NOTIFICATION = 'knm-epgu-notification';
export const KNM_VERIFIED_PERSON = 'verified-person';
export const ORGANIZATION_FOR_SELECT = 'organization_for_selec';
export const KNM_VIOLATIONS_LIST = 'violations-list';
export const KNM_OBJECTS_INFO = 'objects-info';
export const KNM_CHECKLIST_INFO = 'checklist-info';
export const KNM_MEETING_INFO = 'meeting-info';
export const KNM_EVENT_SUBJECT = 'event-subject';
export const KNM_ACT = 'act';
export const KNM_RESULT_DECISIONS = 'result-decisions';
export const AGREEMENTS = 'agreements';
export const REPEAT_PASSPORTS = 'repeat_passports';
export const KNM_JUDGMENTS = 'judgments';
export const KNM_OTHER_INFO = 'other-info';
export const KNM_STATUS_EXCHANGE = 'status-exchange';
export const KNM_NOTIFICATION = 'subjectNotifications';
export const ROUTE_KNM_INFO = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_INFO}`;
export const ROUTE_KNM_CONTROL_AGENCY = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_CONTROL_AGENCY}`;
export const ROUTE_KNM_VIOLATIONS_LIST = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_VIOLATIONS_LIST}`;
export const ROUTE_KNM_RESULTS = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_RESULTS}`;
export const ROUTE_KNM_VERIFIED_PERSON = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_VERIFIED_PERSON}`;
export const ROUTE_KNM_REQUIREMENTS = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_REQUIREMENTS}`;
export const ROUTE_KNM_CHECK_SHEETS = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_CHECK_SHEETS}`;
export const ROUTE_KNM_DOCUMENTS = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_DOCUMENTS}`;
export const ROUTE_KNM_PREVIOUS = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_PREVIOUS}`;
export const ROUTE_KNM_HISTORY = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_HISTORY}`;
export const ROUTE_KNM_EXECUTION_HISTORY = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_EXECUTION_HISTORY}`;
export const ROUTE_KNM_OBJECTS_INFO = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_OBJECTS_INFO}`;
export const ROUTE_KNM_CHECKLIST_INFO = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_CHECKLIST_INFO}`;
export const ROUTE_KNM_EVENT_SUBJECT = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_EVENT_SUBJECT}`;
export const ROUTE_KNM_ACT = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_ACT}`;
export const ROUTE_KNM_RESULT_DECISIONS = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_RESULT_DECISIONS}`;
export const ROUTE_KNM_OTHER_INFO = (id: string | number) => `${ROUTE_KNM(id)}#${KNM_OTHER_INFO}`;

export const ROUTE_PM = (id: string | number) => `${ROUTE_BASE}/pm/${id}`;
export const ROUTE_PM_FROM_ANALYTICS__ID = (id: string | number) => `${ROUTE_BASE}/pm/analytics/${id}`;
export const ROUTE_PM_NEW = ROUTE_PM(NEW_KNM_ID);
export const ROUTE_PM_ID = `${ROUTE_BASE}/pm/:id`;
export const ROUTE_ANALYTICS_PM_ID = `${ROUTE_BASE}/pm/analytics/:id`;
export const PM_INFO = 'info';
export const PM_WARNING = 'warning';
export const PM_EVENT_SUBJECT = 'eventSubject';
export const PM_INSPECTORS = 'inspectors';
export const PM_SUBJECT = 'subject';
export const PM_ACT = 'act';
export const PM_OBJECTS = 'objects';
export const PM_REASONS = 'reasons';
export const PM_EVENTS = 'events';
export const PM_SUSPENSION_EVENTS = 'pmSuspensionEvents';
export const PM_HAS_NOTIFICATIONS = 'has-notifications';
export const PM_COLLABORATING = 'collaborating';
export const PM_IS_REJECT_SUBJECT = 'is-reject-subject';
export const PM_RESULT_OF_INSPECTION = 'result-of-inspection';
export const PM_REJECT = 'pm-reject';

export const ROUTE_DECISION = (id: string | number) => `${ROUTE_BASE}/decision/${id}`;
export const ROUTE_DECISION_NEW = ROUTE_DECISION(NEW_KNM_ID);
export const ROUTE_DECISION_ID = `${ROUTE_BASE}/decision/:id`;
export const DECISION_VIOLATIONS = 'violations';
export const IS_NEED_TO_ADD_ACT_ID = 'isNeedToAddAct';
export const DECISION_EVENTS = 'events';
export const DECISION_INFO = 'decision-info';
export const DECISION_COMPLAINT = 'complaint';
export const USER_NOTIFICATION = `${ROUTE_LK}/user-notification`;
export const DECISION_RESULT = 'decision-result';
export const DECISION_REASON = 'decision-reason';
export const UAV_TECHNOLOGIES = 'uavTechnologies';

export const getDecisionRiskIndicatorsBlockId = (id: string) => `reasons[${id}].riskIndicators`;
export const getDecisionRiskIndicatorBlockId = (reasonId: string, indicatorRiskId: string) =>
  `reasons[${reasonId}].riskIndicators[${indicatorRiskId}]`;
export const getComplexDataBlockId = (id: string) => `${id}`;
export const getAgreementsBlockId = (id: string) => `agreements[${id}]`;

export const baseRoutes = [
  ROUTE_LK,
  ROUTE_FEEDBACK,
  ROUTE_KNM_ID,
  ROUTE_ANALYTICS_KNM_ID,
  ROUTE_KNM_LIST,
  ROUTE_KNM_LIST_BY_PLAN,
  ROUTE_KNM_PREVIEW,
  ROUTE_NEWS,
  ROUTE_PLAN,
  ROUTE_PM_ID,
  ROUTE_ANALYTICS_PM_ID,
  ROUTE_PREVENTION,
  ROUTE_DECISION_ID,
  ROUTE_DECISIONS,
  ROUTE_REGISTRY_EGRIP,
  ROUTE_REGISTRY_EGRUL,
  ROUTE_REGISTRY_MSP,
  ROUTE_REGISTRY_OEZ,
  ROUTE_REGISTRY_SPV,
  ROUTE_REGISTRY_TOSER,
  ROUTE_REPORTS,
  ROUTE_SEARCH,
  ROUTE_SIMILARITIES,
  ROUTE_TEMPLATES,
  ROUTE_TEMPLATES_EXPORT,
  ROUTE_TEMPLATES_IMPORT,
];

export const adminRoutes = [
  ROUTE_SMEV_MONITORING,
  ROUTE_LK,
  ROUTE_ADMIN_ADD_NEWS,
  ROUTE_FEEDBACK,
  ROUTE_NEWS,
  ROUTE_SEARCH,
];
export const prosecutorRoutes = [...baseRoutes, ROUTE_ANALYTICS_KNM, ROUTE_ANALYTICS];
export const ombudsmanRoutes = [
  ROUTE_LK,
  ROUTE_FEEDBACK,
  ROUTE_KNM_ID,
  ROUTE_KNM_LIST,
  ROUTE_KNM_PREVIEW,
  ROUTE_NEWS,
  ROUTE_PM_ID,
  ROUTE_PREVENTION,
  ROUTE_DECISION_ID,
  ROUTE_DECISIONS,
  ROUTE_REGISTRY_EGRIP,
  ROUTE_REGISTRY_EGRUL,
  ROUTE_REGISTRY_MSP,
  ROUTE_REGISTRY_OEZ,
  ROUTE_REGISTRY_SPV,
  ROUTE_REGISTRY_TOSER,
  ROUTE_SEARCH,
];
